<template>
  <v-container fluid>

    <v-row dense>
      <v-col align="center">
        <div v-if="!searchResults"><h1>Please Enter a Reddit Post to Search</h1></div>
        <div v-if="searchResults && matches.length === 0"><h1>No Matches Found</h1></div>
        <div v-if="searchResults && matches.length > 0">Found {{matches.length}} in {{searchResults.search_times.total_search_time}}s</div>
      </v-col>
    </v-row>
    <v-row dense v-if="searchResults !== null">
      <v-col
          v-for="match in matches"
          :key="match.title"
          cols="12" xl="3" lg="4" md="6" sm="12" xs="12"

      >
        <SearchResultNew :checked-post="searchResults.checked_post" :bg-color="bgColor" :match="match"  v-on="$listeners"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import SearchResultNew from "@/components/search/SearchResultNew";

export default {
  name: "SearchResults",
  components: {SearchResultNew},
  props: {
    searchResults: Object,
    matches: Array,
    sortOrder: String
  },
  data: () => ({
    bgColor: "#ffffff",
  }),
}
</script>

<style scoped>

</style>
